export default {"src":"/_next/static/image/public/images/ic_guest_appointment.0d6e4ae6d3a8dbc461a70c01591304ad.svg","height":132,"width":154};